import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function PaymentButton() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Payment Button" breadcrumbItem="Payment Button" />
          <h4> Payment Button</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default PaymentButton;
